import Attribute from "./Attribute";
import EntityType from "./EntityType";
import EntityDefinitions from "../App/EntityDefinitions";

class RefAttribute extends Attribute {
    constructor(name, def) {
        super(name, def);
        this.type = 'ref';
        this.subtype = def.type.refType;
        this.definition = def.type.definition;
        this.values = def.type.values;
    }

    fromJson(data) {
        if (data === null || typeof data !== 'object') {
            return data;
        }

        const et = new EntityType(this.definition || EntityDefinitions.getDefinition(this.subtype));
        return et.createEntity(data)
    }

    toJson(value) {
        if (value === null) {
            return value;
        }
        return typeof value === 'object' ?  value.id : value;
    }
}

export default RefAttribute;